import { Button, makeStyles, Snackbar } from "@material-ui/core";

import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { addNewCategory } from "../reduxSaga/actions";
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";

// const useStyles = makeStyles((theme) => ({
//   fab: {
//     position: "fixed",
//     bottom: 20,
//     right: 20,
//   },
//   container: {
//     borderRadius: 10,
//     boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
//     width: 500,
//     height: 300,
//     backgroundColor: "white",
//     position: "absolute",
//     top: -30,
//     bottom: 0,
//     left: 0,
//     right: 0,
//     margin: "auto",
//     [theme.breakpoints.down("sm")]: {
//       width: "100vw",
//       height: "100vh",
//     },
//   },
//   form: {
//     padding: theme.spacing(2),
//   },
//   item: {
//     marginBottom: theme.spacing(3),
//     marginTop: theme.spacing(3),
//   },

//   cancelAndAddButtom: {
//     marginBottom: theme.spacing(3),
//     marginTop: theme.spacing(5),
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },

//   input: {
//     "&::placeholder": {
//       fontStyle: "italic",
//     },
//   },
// }));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ConfirmAddSubFamily = ({
  setOnConfirmAddSubFamily,
  confirmSubFamilyModel,
  setIsCancel,
}) => {
  const dispatch = useDispatch();
  // const familyNotification = useSelector(
  //   (state) => state.staff.familyNotification
  // );

  const [open, setOpen] = React.useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const handleClose = () => {
    setOpen(false);
    setOnConfirmAddSubFamily(false);
  };

  const handleConfirm = () => {
    setOpen(false);
    setOnConfirmAddSubFamily(false);

    let categoryModel = {
      categoryName: confirmSubFamilyModel.categoryName,
      description: confirmSubFamilyModel.description,
      familyName: confirmSubFamilyModel.productFamilyName,
      idProductFamily: confirmSubFamilyModel.idProductFamily,
      idProductSubFamily: confirmSubFamilyModel.idSubFamily,
      idUserCreation: confirmSubFamilyModel.idUserCreation,
      subFamilyName: confirmSubFamilyModel.subFamilyName,
      sku: confirmSubFamilyModel.sku,
    };

    dispatch(addNewCategory(categoryModel));

    setIsCancel(false);
    setTimeout(setOnConfirmAddSubFamily(false), 1000);
    setOpen(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
    setIsCancel(true);
  };

  // categoryName: categoryName,
  // description: categoryDesc,
  // idProductFamily: familyId,
  // idUserCreation : 0 ,
  // subFamilyName : subFamilyName

  return (
    <>
      <Dialog
        open={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Confirmer vous l'ajout?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div class="card-body">
              <div class="row" style={{ marginTop: -20 }}>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Libellé: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSubFamilyModel.categoryName}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Nom de famille </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSubFamilyModel.productFamilyName}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Nom de sous famille </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSubFamilyModel.subFamilyName}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Note : </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmSubFamilyModel.description}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Image : </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    loading{" "}
                  </label>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ marginTop: -20 }}>
          <Button onClick={handleClose} color="primary">
            Annuler
          </Button>
          <Button onClick={handleConfirm} color="primary">
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ConfirmAddSubFamily;
